import React, { useEffect, useState } from 'react';
import '../CSS/Global.css';
import Philosophy from '../Components/Philosophy';

const About = () => {
    const [experienceCount, setExperienceCount] = useState(0);
    const [teamCount, setTeamCount] = useState(0);

    // Animation duration in milliseconds
    const duration = 2000;

    useEffect(() => {
        const startExperienceCount = 0;
        const endExperienceCount = 45;
        const startTeamCount = 0;
        const endTeamCount = 25;

        // Counter function for experience
        const experienceCounter = setInterval(() => {
            if (startExperienceCount < endExperienceCount) {
                setExperienceCount((prev) => Math.min(prev + 1, endExperienceCount));
            } else {
                clearInterval(experienceCounter);
            }
        }, duration / endExperienceCount);

        // Counter function for team
        const teamCounter = setInterval(() => {
            if (startTeamCount < endTeamCount) {
                setTeamCount((prev) => Math.min(prev + 1, endTeamCount));
            } else {
                clearInterval(teamCounter);
            }
        }, duration / endTeamCount);

        // Cleanup intervals on component unmount
        return () => {
            clearInterval(experienceCounter);
            clearInterval(teamCounter);
        };
    }, []);

    return (
        <>
            <div className="about-page">
                <h1>About Us</h1>
                <p>In the realm of television, Mazhar has served as both an art director and assistant art director for numerous notable productions. As an art director, he contributed to projects such as CIF (White Sand Production), Balaji telefilms, Sphere origin, Dashami creation & Banijay asia.</p>
            </div>
            <Philosophy />
            <div className="target">
                <div className="target-list">
                    <p className='round'>Mazhar khan</p>
                    <h2>More Details</h2>
                    <p className='para'>Mazhar Khan’s extensive experience and artistic vision have made him a respected name in the creative industry, consistently delivering excellence in every project he undertakes</p>
                    {/* <div className="target-count">
                        <div className="target-count-list">
                            <h2>{experienceCount}</h2>
                            <p>experience</p>
                        </div>
                        <div className="target-count-list">
                            <h2>{teamCount}</h2>
                            <p>Professional Team</p>
                        </div>
                    </div> */}
                </div>
                <div className="target-list column2">
                    <div className="target-card">
                        <i className="fa-solid fa-eye"></i>
                        <h2>vision</h2>
                        <p>To be a leading force in the entertainment industry.</p>
                    </div>
                    <div className="target-card">
                        <i className="fa-solid fa-bullseye"></i>
                        <h2>mission</h2>
                        <p>To innovate and inspire through creative art direction.</p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default About;
